import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { emailMasking } from "../../../util/CommonReadonlyMasking";
import { ApplicationState } from "../../../store";
import * as httpClient from "../../../util/httpClient";
import { Notification } from "../../common/Notification";
import { useTranslation } from "react-i18next";
import * as MyAccountActions from "../../../store/myAccount/actions";
import { useForm, Controller } from "react-hook-form";
import { PATTERNS } from "../../../util/patterns";
import { CAProvinces, stateList } from "../../../util/CommonLists";
import { GetCountryListAndInternationalSupport } from "../../../util/countryListAndInternationalSupport";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { myAccountServiceStatePII } from "../../../store/common";
import * as services from "../../../store/service";
import { isNullOrUndefined } from "util";
import * as LoginActions from "../../../store/loginService/actions";
import PhoneInput, { isValidPhoneNumber, formatPhoneNumber, parsePhoneNumber, getCountryCallingCode } from "react-phone-number-input";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { isValidPhoneNo } from "../../../util/phoneNumberValidationUtil";
import { Divider } from "antd";
import { GetAccountInformation } from "../../../store/service";

const Account = (props: any) => {
    const dispatch = useDispatch();
    const getAccountInformation = (forceReload?: boolean) => dispatch(MyAccountActions.actionCreators.getAccountInformation(forceReload));
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const [visibleEmail, setVisisbleEmail]: any = useState([]);
    const personalAccountInformation = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._personalAccountInformation
                : null
            : null
    );
    const contactPreference = useSelector((state: ApplicationState) =>
        state.myAccountServiceState
            ? state.myAccountServiceState._unifiedAccountInfo
                ? state.myAccountServiceState._unifiedAccountInfo._contactPreference
                : null
            : null
    );
    const [showEdit, setShowEdit] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [errorMsg, seterrorMsg] = useState("");
    const { t: tLang } = useTranslation();
    const [hasEmailError, setEmailHasError] = useState(false);
    const [hasUserNameError, setUserNameHasError] = useState(false);
    const { supportInternational, getCountries } = GetCountryListAndInternationalSupport();
    const [zipCode, setZipCode] = useState(i18nService.get("ZipCode"));
    const allowLoginWithUserName: boolean = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.allowLoginWithUserName
            ? state.configurationState.configuration.partnerConfig.allowLoginWithUserName
            : false
    );
    const [piiState, setPiiState] = useState({} as myAccountServiceStatePII);
    const loggedInUserName = useSelector(
        (state: ApplicationState) => (state.loggedInUser && state.loggedInUser.userInfo && state.loggedInUser.userInfo.loginUserName) || null
    );
    const setUserPhoneNumber = (phoneNumber: string) => dispatch(LoginActions.actionCreators.updateLoggedInUserPhone(phoneNumber));
    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );

    const isAVGId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2659
                ? true
                : false
            : false
    );

    const isAVGTestId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2662
                ? true
                : false
            : false
    );

    const setCountry = () => {
        if (!supportInternational && accountInfo!.country == null) {
            accountInfo!.country = "US";
        }
    };

    const countryChangeDetected = () => {
        i18nService.setRegionBasedonCountry(watch("country"));
        setZipCode(i18nService.get("ZipCode"));
        setValue("city", "");
        setValue("zipCode", "");
        if (watch("country") !== "US" && watch("country") !== "CA") {
            setValue("state", "");
        } else {
            setValue("state", "---");
        }
    };

    const disableEmailField = useSelector(
        (state: ApplicationState) =>
            (state.configurationState &&
                state.configurationState.configuration &&
                state.configurationState.configuration.partnerConfig &&
                state.configurationState.configuration.partnerConfig.ssoOptions &&
                state.configurationState.configuration.partnerConfig.ssoOptions.disableEmailOnMyAccountScreen) ||
            false
    );

    /**Validation with react-hook-form ***/
    const { register, errors, formState, handleSubmit, watch, clearErrors, setValue, control } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const { isSubmitting } = formState;

    const showEditForm = () => {
        setCountry();
        setShowEdit(true);
    };

    const hideEditForm = () => {
        setValue("country", accountInfo ? accountInfo.country : "US");
        countryChangeDetected();
        setShowEdit(false);
    };

    const save = (accountInformation: any) => {
        if (accountInfo && accountInfo.country) {
            accountInformation.country = accountInfo.country;
        }

        if (supportInternational) {
            accountInformation.country = watch("country");
        } else {
            accountInformation.country = "US";
        }

        if ((accountInformation && accountInformation.country !== "US") || accountInformation.country !== "CA") {
            accountInformation.state = accountInformation.state.toUpperCase().substring(0, 50);
        }

        if (accountInformation && contactPreference) {
            const requestBody = {
                FirstName: accountInformation.firstName,
                LastName: accountInformation.lastName,
                Email: accountInformation.primaryEmail,
                Phone: accountInformation.primaryPhone
                    ? getCountryInfo()
                        ? accountInformation.primaryPhone.replace(/[^0-9+]/g, "")
                        : accountInformation.primaryPhone
                    : accountInformation.primaryPhone,
                PersonalSMS: contactPreference.smsNumber
                    ? getCountryInfo()
                        ? contactPreference.smsNumber.replace(/[^0-9+]/g, "")
                        : contactPreference.smsNumber
                    : contactPreference.smsNumber,
                IsEmailIdentityNotificationOptOut: contactPreference.idCrimeAndBreachNews,
                IsEmailNotificationOptOut: contactPreference.alertNotification,
                IsPushNotificationOptOut: contactPreference.appPushNotification,
                IsSmsNotificationOptOut: contactPreference.textSMSNotification,
                Address1: accountInformation.address1,
                Address2: accountInformation.urbanization ? accountInformation.address2 + ";" + accountInformation.urbanization : accountInformation.address2,
                City: accountInformation.city,
                State: accountInformation.state,
                Country: accountInformation.country,
                ZipCode: accountInformation.zipCode,
                UserName: accountInformation.userName,
            };
            setisLoading(true);
            setEmailHasError(false);
            setUserNameHasError(false);
            httpClient
                .sendRequest("POST", "api/accountInfo/saveContactInformation", requestBody)
                .then((data) => {
                    setisLoading(false);
                    if (data.isSuccess) {
                        props.setDialogue();
                        setUserPhoneNumber(requestBody.Phone);
                        Notification({
                            type: "success",
                            title: "Success",
                            message: tLang("manageAccount.myAccount.membershipInformation.notification.updatedAccountInfoMsg"),
                        });
                        getAccountInformation(true);
                        setShowEdit(false);
                    } else if (data.hasError && data.errors.length > 0) {
                        const index = data.errors.findIndex((x: any) => x === "Email id already exists");
                        if (index > -1) {
                            seterrorMsg(data.errors[index]);
                            setEmailHasError(true);
                        }
                        const idx = data.errors.findIndex((x: any) => x === "User Name already exists");
                        if (idx > -1) {
                            seterrorMsg(data.errors[idx]);
                            setUserNameHasError(true);
                        }
                    }
                })
                .catch(function (error) {
                    setisLoading(false);
                    Notification({
                        type: "error",
                        title: "Error",
                        message: error,
                        duration: 0,
                    });
                });
        }
    };

    const getCountryInfo = () => {
        let currentCountry = accountInfo && accountInfo.country ? accountInfo.country : "";
        let country = watch("country") ? watch("country") : "";

        if ((currentCountry.includes("US") || currentCountry.includes("CA")) && !country) {
            return false;
        } else if (country.includes("US") || country.includes("CA")) {
            return false;
        } else {
            return true;
        }
    };

    const getCountry = () => {
        if (accountInfo && accountInfo.country) {
            return accountInfo.country;
        }

        if (supportInternational) {
            let country = watch("country") ? watch("country") : "US";
            return country;
        }
        return "US";
    };

    const toggleEmailVisibility = (item: any) => {
        if (visibleEmail.length > 0) {
            const index = visibleEmail.findIndex((element: any) => element.primaryEmail === item.primaryEmail);
            if (index >= 0) {
                visibleEmail.splice(index, 1);
                setVisisbleEmail([...visibleEmail]);
            } else {
                setVisisbleEmail([...visibleEmail, item]);
            }
        } else {
            setVisisbleEmail([...visibleEmail, item]);
        }
    };

    const ensureDataFetched = () => {
        setisLoading(true);

        services.GetAccountInformation().then((accountInfoResponse) => {
            setisLoading(false);
            setPiiState({ memberShipNumber: accountInfoResponse._unifiedAccountInfo.memberShipNumber });
        });
    };

    useEffect(ensureDataFetched, []);

    useEffect(() => {
        const el = document.getElementsByClassName("PhoneInputCountry");
        if (el && el.length > 0) {
            try {
                const childs = el[0].children;
                if (childs[0].nodeName === "SELECT") {
                    const selectEl = childs[0] as HTMLSelectElement;
                    selectEl.disabled = true;
                    selectEl.setAttribute("aria-required", `true`);
                }
            } catch {}
        }
    }, [showEdit]);

    const getPrimatyPhoneNumber = () => {
        const country = accountInfo && accountInfo.country ? accountInfo.country : "US";
        let phoneNumber = personalAccountInformation?.primaryPhone;
        if (personalAccountInformation && personalAccountInformation.primaryPhone && !personalAccountInformation.primaryPhone.startsWith("+")) {
            phoneNumber = "+" + getCountryCallingCode(country) + personalAccountInformation.primaryPhone;
        }

        return phoneNumber;
    };

    return (
        <React.Fragment>
            {/* My Account */}
            <div className="box offset-padding">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon" aria-hidden="true">
                            <RenderIcons iconName={"user"} />
                        </div>
                        <div className="box-title-text has-actions">
                            <h2 className="box-title">{isAvastId || isAVGId || isAVGTestId ? "My Profile" : tLang("manageAccount.myAccount.tabTitle")}</h2>
                        </div>
                    </div>
                    <div className="box-description">
                        <p>
                            {tLang("manageAccount.myAccount.membershipInformation.description")}{" "}
                            {isAvastId || isAVGId || isAVGTestId ? "profile" : tLang("manageAccount.myAccount.membershipInformation.infoMsg")}{" "}
                            {tLang("manageAccount.myAccount.membershipInformation.message")}.
                        </p>
                    </div>
                    {!showEdit && (
                        <div className="box-actions">
                            <button type="button" className="btn-default btn-grey-dot" id="my-account-info" onClick={() => showEditForm()}>
                                <span className="btn-text">
                                    {tLang("manageAccount.myAccount.membershipInformation.editButtonText")}{" "}
                                    <span className="sr-only">{isAvastId || isAVGId || isAVGTestId ? "My Profile" : "My Account"} Info</span>
                                </span>
                                <span className="btn-icon">
                                    <RenderIcons iconName="pen" />
                                </span>
                            </button>
                        </div>
                    )}
                </div>

                <div className={isLoading ? "box-content loading" : "box-content"}>
                    {/* Grid Content */}
                    {!showEdit && accountInfo && personalAccountInformation && (
                        <div role="grid" className="data-grid " id="my-account-info-grid" aria-hidden="false">
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-full-name-display">
                                        {tLang("manageAccount.myAccount.membershipInformation.label.fullName")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-full-name-display">
                                        {personalAccountInformation.firstName + " " + personalAccountInformation.lastName}
                                    </div>
                                </div>
                            </div>
                            {allowLoginWithUserName && !isNullOrUndefined(personalAccountInformation.userName) && !isNullOrUndefined(loggedInUserName) && (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-user-display">
                                            Login Username
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="label-user-display">
                                            {personalAccountInformation.userName}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {(accountInfo && accountInfo.isSSOUser === true ? !disableEmailField : true) && (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-email-display">
                                            {tLang("manageAccount.myAccount.membershipInformation.label.primaryEmail")}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="label-email-display">
                                            {personalAccountInformation.primaryEmail ? emailMasking(personalAccountInformation.primaryEmail) : ""}
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-phone-display">
                                        {tLang("manageAccount.myAccount.membershipInformation.label.primaryPhone")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-phone-display">
                                        {personalAccountInformation.primaryPhone
                                            ? isValidPhoneNumber(personalAccountInformation.primaryPhone)
                                                ? formatPhoneNumber(personalAccountInformation.primaryPhone)
                                                : personalAccountInformation.primaryPhone
                                            : ""}
                                    </div>
                                </div>
                            </div>
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-street-display">
                                        {tLang("manageAccount.myAccount.membershipInformation.label.street")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-street-display">
                                        <span>{accountInfo.address1}</span>
                                        {accountInfo.address2 && accountInfo.address2.length > 0 && (
                                            <p> {accountInfo.address2.includes(";") ? accountInfo.address2.split(";")[0] : accountInfo.address2}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {(accountInfo.state==="PR") && (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-street-display2">
                                            Urbanization
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="label-street-display2">
                                            {accountInfo.address2 && accountInfo.address2.includes(";") ? accountInfo.address2.split(";")[1] : ""}
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-state-display1">
                                        {tLang("manageAccount.myAccount.membershipInformation.label.country")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    {supportInternational ? (
                                        <div role="gridcell" className="data-value" aria-labelledby="label-state-display1">
                                            {getCountries.countryList.length &&
                                                getCountries.countryList.find((s: any) => s.countryCode === accountInfo.country)?.name}
                                        </div>
                                    ) : (
                                        <div role="gridcell" className="data-value" aria-labelledby="label-state-display1">
                                            United States
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-city-display">
                                        {tLang("manageAccount.myAccount.membershipInformation.label.city")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-city-display">
                                        {accountInfo.city}
                                    </div>
                                </div>
                            </div>

                            {accountInfo && accountInfo.country === "US" ? (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-state-display2">
                                            {tLang("manageAccount.myAccount.membershipInformation.label.state")}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="label-state-display2">
                                            {stateList.find((s) => s.value === accountInfo.state)?.name}
                                        </div>
                                    </div>
                                </div>
                            ) : accountInfo && accountInfo.country === "CA" ? (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-state-display3">
                                            Province
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="label-state-display3">
                                            {CAProvinces.find((s) => s.value === accountInfo.state)?.name}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-state-display4">
                                            Region
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="label-state-display4">
                                            {accountInfo.state}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {accountInfo && accountInfo.country === "CA" ? (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-zip-display">
                                            {tLang("manageAccount.myAccount.membershipInformation.label.postalCode")}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="label-zip-display">
                                            {accountInfo.zipCode}
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-zip-display">
                                            {tLang("manageAccount.myAccount.membershipInformation.label.zipcode")}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div role="gridcell" className="data-value" aria-labelledby="label-zip-display">
                                            {accountInfo.zipCode}
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-member-id-display">
                                        {tLang("manageAccount.myAccount.membershipInformation.label.memberId")}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                    <div role="gridcell" className="data-value" aria-labelledby="label-member-id-display">
                                        {piiState.memberShipNumber}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Form Content */}

                    {showEdit && personalAccountInformation && accountInfo && (
                        <div id="my-account-info-form">
                            <form id="my-account-info-form-container" onSubmit={handleSubmit(save)}>
                                <fieldset className="form-row inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                <label htmlFor="label-full-name">
                                                    {tLang("manageAccount.myAccount.membershipInformation.label.fullName")}{" "}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </label>{" "}
                                            </legend>
                                        </div>

                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={errors["firstName"] ? "form-row row status-error" : "form-row row"}>
                                                        <div className="form-row row">
                                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                <label htmlFor="label-first-name">
                                                                    First Name{" "}
                                                                    <span className="required" title="Mandatory">
                                                                        *
                                                                    </span>
                                                                </label>
                                                            </div>
                                                            <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    className="inputbox"
                                                                    id="label-first-name"
                                                                    name="firstName"
                                                                    placeholder={tLang("manageAccount.myAccount.membershipInformation.placeholder.firstName")}
                                                                    maxLength={30}
                                                                    defaultValue={personalAccountInformation.firstName}
                                                                    ref={register({ pattern: PATTERNS.FIRSTNAME.pattern, required: true })}
                                                                    aria-required="true"
                                                                />
                                                                {errors.firstName && errors.firstName.type === "pattern" && (
                                                                    <span className="form-error">{tLang(PATTERNS.FIRSTNAME.message) }</span>
                                                                )}
                                                                {errors.firstName && errors.firstName.type === "required" && (
                                                                    <span className="form-error">{tLang("manageAccount.myAccount.membershipInformation.validation.firstName.required")}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div className={errors["lastName"] ? "form-row row status-error" : "form-row row"}>
                                                        <div className="form-row row">
                                                            <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                <label htmlFor="label-last-name">
                                                                    Last Name{" "}
                                                                    <span className="required" title="Mandatory">
                                                                        *
                                                                    </span>{" "}
                                                                </label>
                                                            </div>
                                                            <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                                                <input
                                                                    type="text"
                                                                    className="inputbox"
                                                                    id="label-last-name"
                                                                    placeholder={tLang("manageAccount.myAccount.membershipInformation.placeholder.lastName")}
                                                                    name="lastName"
                                                                    maxLength={30}
                                                                    defaultValue={personalAccountInformation.lastName}
                                                                    ref={register({
                                                                        required: true,
                                                                        pattern: PATTERNS.LASTNAME.pattern,
                                                                    })}
                                                                    aria-required="true"
                                                                />
                                                                {errors.lastName && errors.lastName.type === "pattern" && (
                                                                    <span className="form-error">{tLang(PATTERNS.LASTNAME.message)}</span>
                                                                )}

                                                                {errors.lastName && errors.lastName.type === "required" && (
                                                                    <span className="form-error">{tLang("manageAccount.myAccount.membershipInformation.validation.lastName.required")}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                {allowLoginWithUserName && !isNullOrUndefined(personalAccountInformation.userName) && !isNullOrUndefined(loggedInUserName) && (
                                    <fieldset className="form-row no-margin inline">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <legend className="legend-label">
                                                    Login Username{" "}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </legend>
                                            </div>

                                            <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                <div className="row ">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <div className={errors["userName"] ? "form-row row status-error" : "form-row row"}>
                                                            <div className="form-row row">
                                                                <div className="form-label sr-only col-xs-12  col-no-gutter">
                                                                    <label htmlFor="label-user-name">Number </label>
                                                                </div>
                                                                <div role="alert" className="form-input col-xs-12  col-no-gutter">
                                                                    <input
                                                                        type="text"
                                                                        className="inputbox"
                                                                        id="label-user-name"
                                                                        placeholder="User Name"
                                                                        name="userName"
                                                                        maxLength={30}
                                                                        defaultValue={personalAccountInformation.userName}
                                                                        ref={register({
                                                                            required: true,
                                                                            pattern: PATTERNS.USERNAME_OR_EMAIL.pattern,
                                                                        })}
                                                                    />

                                                                    {errors.userName && errors.userName.type === "pattern" && (
                                                                        <span className="form-error">{PATTERNS.USERNAME_OR_EMAIL.message}</span>
                                                                    )}

                                                                    {errors.userName && errors.userName.type === "required" && (
                                                                        <span className="form-error">User Name is required.</span>
                                                                    )}
                                                                    {hasUserNameError && <span className="form-error">{errorMsg}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                )}
                                {(accountInfo && accountInfo.isSSOUser === true ? !disableEmailField : true) && (
                                    <div className={errors["primaryEmail"] ? "form-row row status-error" : "form-row row"}>
                                        <div className="form-row inline row">
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="label-email">
                                                    {tLang("manageAccount.myAccount.membershipInformation.label.primaryEmail")}{" "}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </label>
                                            </div>
                                            <div role="alert" className="form-input col-xs-12 col-sm-6 col-no-gutter">
                                                <input
                                                    type="text"
                                                    className={
                                                        visibleEmail.findIndex((element: any) => element.primaryEmail === personalAccountInformation.primaryEmail) <
                                                            0 && personalAccountInformation.primaryEmail !== ""
                                                            ? "inputbox hide-input"
                                                            : "inputbox"
                                                    }
                                                    id="label-email"
                                                    placeholder="Email Address"
                                                    name="primaryEmail"
                                                    defaultValue={personalAccountInformation.primaryEmail}
                                                    ref={register({
                                                        required: true,
                                                        pattern: PATTERNS.EMAIL.pattern,
                                                    })}
                                                    aria-required="true"
                                                />
                                                <span
                                                    hidden={
                                                        personalAccountInformation.primaryEmail === "" ||
                                                        visibleEmail.findIndex(
                                                            (element: any) => element.primaryEmail === personalAccountInformation.primaryEmail
                                                        ) >= 0
                                                    }
                                                    style={{ marginTop: "20px " }}
                                                >
                                                    <p style={{ wordWrap: "break-word", maxWidth: "70vw" }}>
                                                        {" "}
                                                        {personalAccountInformation.primaryEmail ? emailMasking(personalAccountInformation.primaryEmail) : ""}{" "}
                                                    </p>
                                                </span>
                                                <div className="form-input-button">
                                                    {personalAccountInformation.primaryEmail !== "" && (
                                                        <button
                                                            type="button"
                                                            className="btn-default btn-icon-only btn-no-padding"
                                                            onClick={() => {
                                                                toggleEmailVisibility(personalAccountInformation);
                                                            }}
                                                            title={
                                                                visibleEmail.findIndex(
                                                                    (element: any) => element.primaryEmail === personalAccountInformation.primaryEmail
                                                                ) < 0
                                                                    ? tLang("identityVault.monitoredInformation.businessInfoWidget.showEmailToolTip")
                                                                    : tLang("identityVault.monitoredInformation.businessInfoWidget.hideEmailToolTip")
                                                            }
                                                        >
                                                            <span className="btn-icon">
                                                                <em
                                                                    className={`las ${
                                                                        visibleEmail.findIndex(
                                                                            (element: any) => element.primaryEmail === personalAccountInformation.primaryEmail
                                                                        ) < 0
                                                                            ? "la-eye"
                                                                            : "la-eye-slash"
                                                                    }`}
                                                                ></em>
                                                            </span>
                                                            <span className="btn-text">Show / Hide Email Text</span>
                                                        </button>
                                                    )}
                                                </div>
                                                {errors.primaryEmail && errors.primaryEmail.type === "required" && (
                                                    <span className="form-error">{tLang("manageAccount.myAccount.membershipInformation.validation.email.required")}</span>
                                                )}
                                                {errors.primaryEmail && errors.primaryEmail.type === "pattern" && (
                                                    <span className="form-error">{tLang(PATTERNS.EMAIL.message)}</span>
                                                )}
                                                {hasEmailError && <span className="form-error">{errorMsg}</span>}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <fieldset className="form-row no-margin inline">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <legend className="legend-label">
                                                {" "}
                                                <label htmlFor="my-account-phone-number">
                                                    {tLang("manageAccount.myAccount.membershipInformation.label.primaryPhone")}{" "}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </label>{" "}
                                            </legend>
                                        </div>

                                        <div className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="row ">
                                                <div className="col-xs-12 col-no-gutter">
                                                    <div
                                                        className={`form-row row ${errors["primaryPhone"] && "status-error"} ${
                                                            errors["primaryPhone"] && watch("primaryPhone") && !parsePhoneNumber(watch("primaryPhone"))
                                                                ? "country-error"
                                                                : ""
                                                        }`}
                                                    >
                                                        <div className="form-row row">
                                                            <div className="form-label sr-only col-xs-12  col-no-gutter">
                                                                <label htmlFor="label-phone-number">Number </label>
                                                            </div>
                                                            <div role="alert" className="form-input col-xs-12  col-no-gutter">
                                                                <Controller
                                                                    name="primaryPhone"
                                                                    control={control}
                                                                    defaultValue={getPrimatyPhoneNumber()}
                                                                    className="inputbox"
                                                                    rules={{
                                                                        required: true,
                                                                        validate: (value) => (value ? isValidPhoneNo(getCountry(), value) : false),
                                                                    }}
                                                                    aria-required="true"
                                                                    render={({ onChange, value }) => (
                                                                        <PhoneInput
                                                                            value={value}
                                                                            onChange={onChange}
                                                                            international={false}
                                                                            className="inputbox"
                                                                            addInternationalOption={false}
                                                                            defaultCountry={getCountry()}
                                                                            countries={[getCountry()]}
                                                                            id="my-account-phone-number"
                                                                            placeholder={tLang("manageAccount.myAccount.membershipInformation.placeholder.phoneNumber")}
                                                                            maxLength={15}
                                                                            minLength={10}
                                                                            aria-required="true"
                                                                        />
                                                                    )}
                                                                />
                                                                {!!errors["primaryPhone"] && errors["primaryPhone"].type === "required" && (
                                                                    <span className="form-error">{tLang("manageAccount.myAccount.membershipInformation.validation.phone.required")}</span>
                                                                )}
                                                                {!!errors["primaryPhone"] && errors["primaryPhone"].type === "validate" && (
                                                                    <span className="form-error">{tLang("manageAccount.myAccount.membershipInformation.validation.phone.invalid")}</span>
                                                                )}
                                                                {!!errors["primaryPhone"] &&
                                                                    errors["primaryPhone"].type === "minLength" &&
                                                                    (getCountryInfo() ? (
                                                                    <span className="form-error">{tLang("manageAccount.myAccount.membershipInformation.validation.phone.invalidCategory1")}</span>
                                                                    ) : (
                                                                        <span className="form-error">
                                                                            {tLang("manageAccount.myAccount.membershipInformation.validation.phone.invalidCategory3")}
                                                                        </span>
                                                                    ))}
                                                                {!!errors["primaryPhone"] &&
                                                                    errors["primaryPhone"].type === "maxLength" &&
                                                                    (getCountryInfo() ? (
                                                                    <span className="form-error">{tLang("manageAccount.myAccount.membershipInformation.validation.phone.invalidCategory2")}</span>
                                                                    ) : (
                                                                        <span className="form-error">
                                                                            {tLang("manageAccount.myAccount.membershipInformation.validation.phone.invalidCategory3")}
                                                                        </span>
                                                                    ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                {/*<fieldset className="form-row inline">*/}
                                <div className="form-row inline row">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <legend className="legend-label">
                                            {" "}
                                            <label htmlFor="label-address-street">
                                                {tLang("manageAccount.myAccount.membershipInformation.label.street")}{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>{" "}
                                        </legend>
                                    </div>

                                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="row">
                                            <div className="col-xs-12 col-no-gutter">
                                                <div className={errors["address1"] ? "form-row row status-error" : "form-row row"}>
                                                    <div className="form-row row">
                                                        <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                            <label htmlFor="label-address1">
                                                                Address Line 1{" "}
                                                                <span className="required" title="Mandatory">
                                                                    *
                                                                </span>
                                                            </label>
                                                        </div>
                                                        <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                className="inputbox"
                                                                id="label-address1"
                                                                name="address1"
                                                                placeholder={tLang("manageAccount.myAccount.membershipInformation.placeholder.address")}
                                                                maxLength={100}
                                                                defaultValue={accountInfo.address1}
                                                                ref={register({ pattern: PATTERNS.STREETADDRESS.pattern, required: true })}
                                                                aria-required="true"
                                                            />
                                                            {errors.address1 && errors.address1.type === "pattern" && (
                                                                <span className="form-error">{tLang(PATTERNS.STREETADDRESS.message)}</span>
                                                            )}
                                                            {errors.address1 && errors.address1.type === "required" && (
                                                                <span className="form-error">
                                                                    {tLang("manageAccount.myAccount.membershipInformation.validation.address.required")}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-xs-12 col-no-gutter">
                                                <div className={errors["address2"] ? "form-row row status-error" : "form-row row"}>
                                                    <div className="form-row row">
                                                        <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                            <label htmlFor="label-address2">Address Line 2</label>
                                                        </div>
                                                        <div role="alert" className="form-input col-xs-12 col-no-gutter">
                                                            <input
                                                                type="text"
                                                                className="inputbox"
                                                                id="label-address2"
                                                                name="address2"
                                                                placeholder={tLang("manageAccount.myAccount.membershipInformation.placeholder.address2")}
                                                                defaultValue={
                                                                    accountInfo.address2 && accountInfo.address2.includes(";")
                                                                        ? accountInfo.address2.split(";")[0]
                                                                        : accountInfo.address2
                                                                }
                                                                maxLength={100}
                                                                ref={register({
                                                                    pattern: PATTERNS.STREETADDRESS.pattern,
                                                                })}
                                                            />
                                                            {errors.address2 && errors.address2.type === "pattern" && (
                                                                <span className="form-error">{tLang(PATTERNS.STREETADDRESS.message)}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <Divider className={errors["address2"] ? "form-row row status-error" : "form-row row"}></Divider>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* </fieldset>*/}
                                {(watch('state') ? watch('state') === "PR": accountInfo.state==="PR") && (
                                    <div className={`form-row inline row ${errors["urbanization"] && "status-error"}`}>
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="label-address-urbanization">Urbanization</label>
                                        </div>
                                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                            <input
                                                type="text"
                                                name="urbanization"
                                                defaultValue={accountInfo.address2 && accountInfo.address2.includes(";") ? accountInfo.address2.split(";")[1] : ""}
                                                className="inputbox"
                                                id="label-address-urbanization"
                                                ref={register({ required: false })}
                                                maxLength={35}
                                                placeholder="Urbanization(Optional)"
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className={errors["country"] ? "form-row row status-error" : "form-row row"}>
                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="label-country">
                                                {tLang("manageAccount.myAccount.membershipInformation.label.country")}{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                            {supportInternational ? (
                                                <select
                                                    className="inputbox"
                                                    id="label-country"
                                                    defaultValue={accountInfo.country}
                                                    name="country"
                                                    disabled={Boolean(accountInfo.country)}
                                                    onChange={() => {
                                                        countryChangeDetected();

                                                        setValue("primaryPhone", "");
                                                        clearErrors(["primaryPhone"]);
                                                    }}
                                                    ref={register({ required: true, validate: (value) => value !== "" })}
                                                    aria-required="true"
                                                >
                                                    {getCountries.countryList.length &&
                                                        getCountries.countryList.map((val: any) => (
                                                            <option key={val.name} value={val.countryCode}>
                                                                {val.name}
                                                            </option>
                                                        ))}
                                                </select>
                                            ) : (
                                                <input
                                                    type="text"
                                                    name="country"
                                                    className="inputbox"
                                                    value="United States"
                                                    id="label-country"
                                                    disabled
                                                    aria-required="true"
                                                />
                                            )}
                                            {errors["country"] && errors["country"].type === "validate" && <span className="form-error">{tLang("manageAccount.myAccount.membershipInformation.validation.country.required")}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className={errors["city"] ? "form-row row status-error" : "form-row row"}>
                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="label-city">
                                                {tLang("manageAccount.myAccount.membershipInformation.label.city")}{" "}
                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                            <input
                                                type="text"
                                                className="inputbox"
                                                id="label-city"
                                                placeholder={tLang("manageAccount.myAccount.membershipInformation.placeholder.city")}
                                                name="city"
                                                defaultValue={accountInfo.city}
                                                ref={register({ required: true, pattern: PATTERNS.CITY.pattern })}
                                                maxLength={20}
                                                aria-required="true"
                                            />

                                            {errors.city && errors.city.type === "required" && <span className="form-error">{tLang("manageAccount.myAccount.membershipInformation.validation.city.required")}</span>}
                                            {errors.city && errors.city.type === "pattern" && (
                                                <span className="form-error">
                                                    {tLang("manageAccount.myAccount.membershipInformation.validation.city.invalid")}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={errors["state"] ? "form-row row status-error" : "form-row row"}>
                                    {watch("country") === "US" || !supportInternational || (!watch("country") && accountInfo && accountInfo.country === "US") ? (
                                        <div className="form-row inline row">
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="label-state">
                                                    {tLang("manageAccount.myAccount.membershipInformation.label.state")}{" "}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </label>
                                            </div>
                                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                <select
                                                    className="inputbox"
                                                    id="label-state"
                                                    name="state"
                                                    defaultValue={accountInfo.state}
                                                    ref={register({ required: true, validate: (value) => value !== "---" })}
                                                    aria-required="true"
                                                >
                                                    {stateList.map((val: any) => (
                                                        <option key={val.name} value={val.value}>
                                                            {val.name}
                                                        </option>
                                                    ))}
                                                </select>

                                                {errors["state"] && errors["state"].type === "validate" && <span className="form-error"> {tLang("manageAccount.myAccount.membershipInformation.validation.state.required")}</span>}
                                            </div>
                                        </div>
                                    ) : watch("country") === "CA" || (!watch("country") && accountInfo && accountInfo.country === "CA") ? (
                                        <div className="form-row inline row">
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="label-state">
                                                    Province{" "}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </label>
                                            </div>
                                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                <select
                                                    className="inputbox"
                                                    id="label-state"
                                                    name="state"
                                                    defaultValue={accountInfo.state}
                                                    ref={register({ required: true, validate: (value) => value !== "---" })}
                                                    aria-required="true"
                                                >
                                                    {CAProvinces.map((val: any) => (
                                                        <option key={val.name} value={val.value}>
                                                            {val.name}
                                                        </option>
                                                    ))}
                                                </select>

                                                {errors["state"] && errors["state"].type === "validate" && (
                                                        <span className="form-error">{tLang("manageAccount.myAccount.membershipInformation.validation.province.required")}</span>
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="form-row inline row">
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="label-state">
                                                    Region{" "}
                                                    <span className="required" title="Mandatory">
                                                        *
                                                    </span>
                                                </label>
                                            </div>
                                            <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                <input
                                                    type="text"
                                                    name="state"
                                                    defaultValue={accountInfo.state}
                                                    ref={register({ required: true, pattern: PATTERNS.REGION.pattern })}
                                                    className="inputbox"
                                                    id="label-state"
                                                    placeholder="Region"
                                                    aria-required="true"
                                                />
                                                        {errors["state"] && errors["state"].type === "required" && <span className="form-error">{tLang("manageAccount.myAccount.membershipInformation.validation.region.required")}</span>}
                                                {errors["state"] && errors["state"].type === "pattern" && (
                                                            <span className="form-error">{tLang("manageAccount.myAccount.membershipInformation.validation.state.invalid")}</span>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className={errors["zipCode"] ? "form-row row status-error" : "form-row row"}>
                                    <div className="form-row inline row">
                                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                            <label htmlFor="label-zipCode">
                                                {i18nService.get("ZipCode.Label") === "Zip Code"
                                                    ? tLang("manageAccount.myAccount.membershipInformation.label.zipcode")
                                                    : i18nService.get("ZipCode.Label") === "Postal Code"
                                                        ? tLang("manageAccount.myAccount.membershipInformation.label.postalCode")
                                                        : i18nService.get("ZipCode.Label")} {" "}

                                                <span className="required" title="Mandatory">
                                                    *
                                                </span>
                                            </label>
                                        </div>
                                        <div role="alert" className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                            <input
                                                type="text"
                                                className="inputbox"
                                                id="label-zipCode"
                                                name="zipCode"
                                                placeholder={ 
                                                    i18nService.get("ZipCode.Label") === "Zip Code"
                                                        ? tLang("manageAccount.myAccount.membershipInformation.label.zipcode")
                                                        : i18nService.get("ZipCode.Label") === "Postal Code"
                                                            ? tLang("manageAccount.myAccount.membershipInformation.label.postalCode")
                                                            : i18nService.get("ZipCode.Label")
                                                }
                                                defaultValue={accountInfo.zipCode}
                                                ref={register({ required: true, pattern: PATTERNS[zipCode.Pattern].pattern })}
                                                maxLength={zipCode.MaxLength}
                                                aria-required="true"
                                            />
                                            {errors.zipCode && errors.zipCode.type === "required" && (
                                                <span className="form-error">
                                                    {i18nService.get("ZipCode.Label") === "Zip Code"
                                                        ? tLang("manageAccount.myAccount.membershipInformation.validation.zipcodeRequired")
                                                        : i18nService.get("ZipCode.Label") === "Postal Code"
                                                            ? tLang("manageAccount.myAccount.membershipInformation.validation.postalcodeRequired")
                                                            : `${i18nService.get("ZipCode.Label")} is required.`}
                                                </span>
                                            )}
                                            {errors.zipCode && errors.zipCode.type === "pattern" && (
                                                <span className="form-error">
                                                    {i18nService.get("ZipCode.Pattern") === "ZIPCODE"
                                                        ? `${tLang("manageAccount.myAccount.membershipInformation.validation.formatInvalidMessage")} ${tLang(
                                                            "manageAccount.myAccount.membershipInformation.validation.zipcodePattern"
                                                        )}`
                                                        : `${tLang("manageAccount.myAccount.membershipInformation.validation.formatInvalidMessage")}
                                                           ${i18nService.get("ZipCode.Label") === "Postal Code" ? tLang("manageAccount.myAccount.membershipInformation.label.postalCode") : i18nService.get("ZipCode.Label")}
                                                           ${tLang("manageAccount.myAccount.membershipInformation.validation.postalCodeFormatMessage")}`}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="margin-vertical-l"></div>

                                <div className="row between-xs">
                                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <ul className="list-inline list-reset">
                                            <li>
                                                <button
                                                    type="button"
                                                    className="btn-default btn-link btn-no-padding btn-no-border btn-min-width"
                                                    onClick={() => hideEditForm()}
                                                >
                                                    <span className="btn-text"> {tLang("manageAccount.myAccount.membershipInformation.cancelButtonText")}</span>
                                                </button>
                                            </li>
                                            <li className="margin-left-s">
                                                <button type="submit" className="btn-default btn-primary btn-min-width" disabled={isSubmitting}>
                                                    <span className="btn-text">{tLang("manageAccount.myAccount.membershipInformation.saveButtonText")}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default Account;
